import { memo, useEffect, useState } from "react";
import { AspectRatio, Box, Center, Image, Stack, Text } from "@chakra-ui/react";
import { useParams } from "react-router";
import ProductCollectionService from "services/product_collection";
import ProductList from "@/components/product/list";
import { useApp } from "contexts/app";

const service = new ProductCollectionService();

const ProductCollectionPage = () => {
  const { id, url_handle } = useParams();
  const { setPageTitle } = useApp();
  const [loading, setLoading] = useState(true);
  const [collection, setCollection] = useState(null);
  const [products, setProducts] = useState([]);
  const [info, setInfo] = useState("");

  const load = async (searchInfo = "") => {
    setLoading(true);
    try {
      const currentCollection = await service.get({ id, url_handle });
      setCollection(currentCollection);
      setPageTitle(currentCollection?.title || "Bộ sưu tập");

      const productList = await service.products({
        id: currentCollection?.id,
        info: searchInfo,
      });
      setProducts(Array.isArray(productList) ? productList : []);
    } catch (error) {
      console.error(error);
      setCollection(null);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id, url_handle]);

  if (loading) {
    return <Text>...loading</Text>;
  }

  if (!collection) {
    return <Text>Không tìm thấy bộ sưu tập</Text>;
  }

  const banner = collection.banner;

  return (
    <Stack gap={4} style={{ paddingBottom: 60 }}>
      {banner && (
        <Box>
          <AspectRatio ratio={4 / 3}>
            <Image src={banner.lg_url || banner.url} borderRadius={8} objectFit="cover" />
          </AspectRatio>
        </Box>
      )}

      {collection.description && (
        <Stack gap={1}>
          <Text color="gray.600">{collection.description}</Text>
        </Stack>
      )}

      {products.length === 0 ? (
        <Center>
          <Text>Chưa có sản phẩm</Text>
        </Center>
      ) : (
        <ProductList data={products} />
      )}
    </Stack>
  );
};

export default memo(ProductCollectionPage);
